import React from 'react';
import { AlignCenter } from '@good/icons';

import { useRichTextEditor } from '../rich-text-editor-context';
import { MenuButton } from './menu-button';

export const AlignCenterButton = () => {
  const { editor, disabled } = useRichTextEditor();

  const isDisabled = disabled || !editor.can().chain().focus().setTextAlign('center').run();
  const onClick = () => editor.chain().focus().setTextAlign('center').run();
  const variant = editor.isActive({ textAlign: 'center' }) ? 'filled' : 'transparent';

  return (
    <MenuButton onClick={onClick} disabled={isDisabled} variant={variant} aria-label='align-center'>
      <AlignCenter />
    </MenuButton>
  );
};
